module.exports = __webpack_public_path__ + "static/media/nextauth.5fbdd0f0.svg";